const prod_na_fallback_url = 'https://d3a3saarspcyfn.cloudfront.net';
// TODO: update with prod url when ready
const sales_assistant_fallback_url =
  'https://atc.federated.ui.ssa.advertising.amazon.dev';
export const interstitial_modal_fallback_url =
  'https://d1wt2ui8v617ir.cloudfront.net';

export const resolveRemoteUrl = (
  value: string | undefined,
  fallback: string,
): string => (/^https?:\/\//.test(value ?? '') ? (value as string) : fallback);

window.__AAC_CHROME_REMOTE_URLS__ = window.__AAC_CHROME_REMOTE_URLS__ || {
  bellDrawer: prod_na_fallback_url,
  salesAssistant: sales_assistant_fallback_url,
  interstitialModal: interstitial_modal_fallback_url,
};

window.__AAC_CHROME_REMOTE_URLS__.bellDrawer = resolveRemoteUrl(
  window.__AAC_CHROME_REMOTE_URLS__.bellDrawer,
  prod_na_fallback_url,
);

window.__AAC_CHROME_REMOTE_URLS__.salesAssistant = resolveRemoteUrl(
  window.__AAC_CHROME_REMOTE_URLS__.salesAssistant,
  sales_assistant_fallback_url,
);

window.__AAC_CHROME_REMOTE_URLS__.interstitialModal = resolveRemoteUrl(
  window.__AAC_CHROME_REMOTE_URLS__.interstitialModal,
  interstitial_modal_fallback_url,
);
